var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#767B85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.39 5.49 8.031.102a.403.403 0 0 0-.476 0L.195 5.49a.403.403 0 1 0 .477.651L7.792.928l7.122 5.213a.401.401 0 0 0 .564-.087.403.403 0 0 0-.088-.564z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.44 6.233a.403.403 0 0 0-.403.403v6.42H9.81V9.553a2.02 2.02 0 0 0-2.017-2.017 2.02 2.02 0 0 0-2.017 2.017v3.505H2.549V6.636a.403.403 0 0 0-.807 0v6.824c0 .223.18.404.403.404H6.18a.403.403 0 0 0 .404-.404V9.552c0-.667.543-1.21 1.21-1.21.667 0 1.21.543 1.21 1.21v3.908a.403.403 0 0 0 .403.403h4.034c.223 0 .404-.18.404-.403V6.636a.403.403 0 0 0-.404-.403z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.bb385f0d7ec33fa2e6784e75c8f01c7b.svg";
export { ForwardRef as ReactComponent };